import React, { useState, useEffect } from 'react';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { createNotebook, getAllNotebooks, deleteNotebook, UpdateNotebook } from 'src/apis/notebook_apis';
import { useAlertContext } from 'src/hooks/use-alert';
import 'src/components/NoteBook/notebook.css'
import DailogContainer from "src/components/DailogContainer";
const DialogWrapper = ({ visbile, onClose,data,deletecall,openEditForm,refreshControl}) => {
  const alert = useAlertContext();

  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteText, setDeleteText] = useState("");


  const handleDeleteClick = (id) => { // function ivoked by delete click
    setDeleteDetailOpen(true); //show the second form for delete confirmation
    setDeleteText("Are you sure you want to delete this deal ?"); //text to show on confirmation form
    onClose(); // hide the dialog
  };

  const handleEditClick = () => {
    openEditForm(true); // open form for edit in main page
    onClose(); // hide the dialog
  };
  const handleConfirmDelete = async () => { // wrapper function for invoking delete call 
    try {
      const response = await deletecall(data.id);
      if (response.success === true) {
        refreshControl()
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Deal deleted succesfully",
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            messages: "Deletion not succesfull",
            index: prev.length,
          },
        ]);
      }
    } catch (error) {
      console.error("Error deleting deal:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error deleting deal",
          index: prev.length,
        },
      ]);
    }
    setDeleteDetailOpen(false);
  };
  const handleConfirmChange = () => { // second level wrapper function fed to 2nd level confirmation form 
    handleConfirmDelete();
  };


  return (
    <div className='notebookContainer'>
      <Grid container>
      <Dialog open={visbile} onClose={onClose}>
                {data  && (
                  <>
                    <DialogTitle><div className='NoteTitle'>Deal Name : {data.name}</div></DialogTitle>
                    <DialogContent>
                      <div className='NoteDescription'>Deal Description : {data.description}</div>
                      <div className='NoteDescription'>Deal Start Date {data.date ? data.date.toString() : ''}</div>
                      <div className='NoteDescription'>Price Agreed : {data.price +"€"}</div>
                    </DialogContent>
                    <DialogActions>
                      <ButtonPolicy className='closeAddNoteButton' onClick={() => onClose()}>Close</ButtonPolicy>
                      <ButtonPolicy className='addNoteBookButton' onClick={() =>
                                            handleDeleteClick(data.id)}>Delete</ButtonPolicy>
                      <ButtonPolicy className='addNoteBookButton' onClick={() => handleEditClick()}>Edit</ButtonPolicy>
                    </DialogActions>
                  </>
                )}
              </Dialog>
      </Grid>
      {deleteDetailOpen && (
                <DailogContainer
                  detailOpen={deleteDetailOpen}
                  setDetailOpen={setDeleteDetailOpen}
                  text={deleteText}
                  onToggleChange={handleConfirmChange}
                />
              )}
    </div>
  );
};

export default DialogWrapper;
